import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth'; // Import getAuth

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAQzlw6vtEbCWWqTn7dkraneDb3e8kTD2w",
  authDomain: "focal-elf-464303-h6.firebaseapp.com", // Corrected
  projectId: "focal-elf-464303-h6", // Corrected
  storageBucket: "focal-elf-464303-h6.appspot.com", // Corrected
  messagingSenderId: "975674340567",
  appId: "1:975674340567:web:64ce2287f13d7a91a16c92"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app); // Initialize and export auth

export { db, auth }; // Export both db and auth
